import type { Int } from "@/types";

import { t } from "i18next";

const buildName = (index: Int, label: string) => `${label} ${index}`;

const buildSlugNameItem = (index: Int, label: string) => {
  const name = buildName(index, label);

  return {
    slug: `slug_${index}`,
    name,
    description: `${t("global:description")} - ${name}`,
  };
};

export const buildSlugNameItems = (length: Int, label: string) =>
  Array.from({ length }, (_, i) => buildSlugNameItem(i + 1, label));
